"use client";

import { ArrowRight, Asterisk } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const team = [{
  name: "Morrie I. Levine",
  role: "PRINCIPAL ATTORNEY",
  bio: "With decades of experience in South Florida, Morrie provides steady, insightful counsel for complex transitions.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/attorney_morrie_levine.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/attorney_morrie_levine.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/attorney_morrie_levine.webp-wvc-sizes"
}, {
  name: "Legal Support",
  role: "PARALEGAL TEAM",
  bio: "Our dedicated support staff ensures every document, deadline, and client communication is handled with precision.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_support_staff.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_support_staff.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_support_staff.png-wvc-sizes"
}, {
  name: "Client Relations",
  role: "INTAKE COORDINATOR",
  bio: "The first point of contact, ensuring your matter is directed to the right expertise with care and efficiency.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/client_relations_coordinator.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/client_relations_coordinator.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/client_relations_coordinator.png-wvc-sizes"
}];
export default function StaffIntroduction() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return;
}